import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { modifiedText } from '../../helpers/symbols';

export const COLUMNS = (default_image, t) => [
    {
        label: t('discover.overview.top_pages.page'),
        key: 'page',
        data: 'page',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            let title = item.title;

            if (!item.title) {
                title = item.page;
            }
            title = modifiedText(title);
            if (csvDownload) return title;

            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) => (event.target.src = default_image)}
                                src={item.image ?? default_image}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong>
                                <a
                                    href={
                                        `/domains/${window.info.id}/pages/page?page=` +
                                        encodeURIComponent(item.page)
                                    }
                                >
                                    {title}
                                </a>
                                <a
                                    target="_blank"
                                    className="link-website d-inline-flex align-items-center justify-content-center"
                                    href={item.page}
                                    rel="noreferrer"
                                >
                                    <i className="icon-external-link"></i>
                                </a>
                            </strong>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('discover.overview.top_pages.uniques'),
        key: 'uniques',
        data: 'uniques',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <span title={item.uniqueHeadlines?.join(' , ')} className="cursor-pointer">
                    {data}
                </span>
            );
        },
    },
    {
        label: t('discover.overview.top_pages.age'),
        key: 'age',
        data: 'age',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div>{numeral(data).format('0,00')} Days</div>;
        },
    },
    {
        label: t('discover.overview.top_pages.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div>{numeral(data).format('0.0a')}</div>;
        },
    },
    {
        label: t('discover.overview.top_pages.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div>{numeral(data).format('0.0a')}</div>;
        },
    },
    {
        label: t('discover.overview.top_pages.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            if (csvDownload) return ctrValue;

            return <div>{numeral(ctrValue).format('0.00%')} </div>;
        },
    },
];

export const FIELD_FOR_DOWNLOADS = (t) => [
    {
        label: t('discover.overview.top_pages.uniqueHeadlines'),
        key: 'uniqueHeadlines',
        data: 'uniqueHeadlines',
        Component: Cell,
        renderCell: ({ data }) => {
            return Array.isArray(data) ? data.join(' , ') : data;
        },
    },
    {
        label: t('discover.overview.top_pages.url'),
        key: 'page',
        data: 'page',
        Component: Cell,
    },
];
